<template>
    <div class="page-chapter-detail">
        <ContentLoader :isDisplay="!contentReady" />
        <template v-if="contentReady">
            <vue-headful :title="fields.detail.chapterTitle + ' - ProbPlus'" :description="'Module ' + fields.detail.moduleNumber + ' Chapter ที่ ' + fields.detail.chapterNumber + ' หัวข้อเรื่อง' + fields.detail.chapterTitle" />
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><router-link :to="'/' + $route.params.lang"><font-awesome-icon :icon="['fas', 'home']" /></router-link></li>
                        <li class="breadcrumb-item"><router-link :to="'/' + $route.params.lang + '/course'">{{ $PPlusEngine.getDictionary($route.params.lang, 'บทเรียนทั้งหมด', 'All Modules') }}</router-link></li>
                        <li class="breadcrumb-item"><router-link :to="'/' + $route.params.lang + '/course/' + fields.detail.moduleNumber">Module {{ fields.detail.moduleNumber }}</router-link></li>
                        <li class="breadcrumb-item active" aria-current="page">Chapter {{ fields.detail.chapterNumber }}</li>
                    </ol>
                </nav>
                <div class="row">
                    <div class="col-md-12 col-lg-8">
                        <section class="board">
                            <div class="global-box-content">
                                <span class="module">{{ fields.detail.moduleTitle }}</span>
                                <h1>{{ fields.detail.chapterTitle }}</h1>
                                <div class="cover" v-if="!isPlayVideo">
                                    <img :src="require('@/assets/module-' + fields.detail.moduleNumber + '/chapter/' + $route.params.lang + '/chapter-' + fields.detail.chapterNumber + '-thumb.jpg')" :alt="fields.detail.chapterTitle" :title="fields.detail.chapterTitle" />
                                    <img :src="require('@/assets/icon-player.png')" :alt="fields.detail.chapterTitle" :title="fields.detail.chapterTitle" class="player" @click="playVideo()" />
                                </div>
                                <section class="video" v-if="isPlayVideo">
                                    <div class="wrapper">
                                        <div class="crop-wrapper">
                                            <div class="cropping">
                                                <div class="player-wrapper">
                                                    <div class="player">
                                                        <iframe frameborder="0" allowfullscreen="1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" :src="'https://www.youtube.com/embed/' + videoId + '?modestbranding=1&iv_load_policy=3&rel=0&autoplay=1&disablekb=0&playsinline=1&color=white'"></iframe>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                                <article v-html="fields.detail.chapterContent">
                                </article>
                            </div>
                        </section>
                    </div>
                    <div class="col-md-12 col-lg-4">
                        <div class="materials"><font-awesome-icon :icon="['fas', 'download']" /> {{ $PPlusEngine.getDictionary($route.params.lang, 'เอกสารบังคับอ่าน', 'Required Reading') }}</div>
                        <div class="alert alert-warning">
                            <font-awesome-icon :icon="['fas', 'exclamation-circle']" /> {{ $PPlusEngine.getDictionary($route.params.lang, 'โปรดทำการดาวน์โหลดเอกสารบังคับอ่านทั้งหมดเพราะเป็นส่วนหนึ่งของเนื้อหาแบบเรียนที่ใช้นับชั่วโมงการอบรม มิเช่นนั้นจะไม่สามารถเข้าสอบได้', 'Please download required reading documents because this is required to be counted as the attendance hours. Otherwise, you will not be able to take the exam') }}
                        </div>
                        <div class="download">
                            <button v-for="(item, index) in materialRequired" :key="index" :class="{ 'read' : checkStatusDownload(item) }" @click="readFile(item)">
                                <i class="pe-7s-check"></i>
                                {{ item.name }}
                                <span>({{ $PPlusEngine.getDictionary($route.params.lang, 'อ่าน', 'Read') }} {{ item.read }} {{ $PPlusEngine.getDictionary($route.params.lang, 'นาที', 'Mins') }})</span>
                            </button>
                            <div class="no-material" v-if="materialRequired.length == 0">
                                <i class="pe-7s-coffee"></i>{{ $PPlusEngine.getDictionary($route.params.lang, 'ไม่มีเอกสารบังคับอ่านแบบเรียนในบทนี้', 'No Required Reading for This Chapter') }}
                            </div>
                        </div>
                        <div class="materials"><font-awesome-icon :icon="['fas', 'download']" /> {{ $PPlusEngine.getDictionary($route.params.lang, 'เอกสารเพื่อเรียนรู้เพิ่มเติม', 'Additional Reading') }}</div>
                        <div class="download">
                            <button v-for="(item, index) in materialOptional" :key="index" :class="{ 'read' : checkStatusDownload(item) }" @click="readFile(item)">
                                <i class="pe-7s-check"></i>
                                {{ item.name }}
                            </button>
                            <div class="no-material" v-if="materialOptional.length == 0">
                                <i class="pe-7s-coffee"></i>{{ $PPlusEngine.getDictionary($route.params.lang, 'ไม่มีเอกสารเพื่อเรียนรู้เพิ่มเติมในบทนี้', 'No Addtional Reading for This Chapter') }}
                            </div>
                        </div>
                    </div>
                </div>
                <section class="other" v-if="fields.other.length > 0">
                    <h3>{{ $PPlusEngine.getDictionary($route.params.lang, 'Chapter อื่นๆ ใน Module', 'Other Chapter in The Module') }}</h3>
                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-4" v-for="(item, index) in fields.other" :key="index">
                            <ChapterBox :fields="item" />
                        </div>
                    </div>
                </section>
            </div>
        </template>
    </div>
</template>

<script>
import ContentLoader from '@/weact/components/ContentLoader';
import ChapterBox from '@/components/ChapterBox';
import PPlusNotify from '@/resources/PPlusNotify';

export default {
    mixins: [PPlusNotify],
    components: {
        ContentLoader,
        ChapterBox,
    },
    data() {
        return {
            contentReady: false,
            fields: {},
            materialRequired: [],
            materialOptional: [],
            videoId: '',
            isPlayVideo: false
        }
    },
    created() {
        let page = this;
        let params = this.$route.params;
        
        setTimeout(function(){
            page.getContent(params);
        }, this.$WeConfig.TimeLoader);
    },
    methods: {
        getContent(params) {
            let apiURL = this.$PPlusConfig.ApiURL;
            let postData = {
                courseNo: params.detail,
                chapterNo: params.chapter
            };

            this.$WeHelper.postAPI(apiURL, '/api/course/get-chapter-detail', postData, this.$PPlusEngine.getHeaderToken()).then((response) => {
                if (response.data.isAuthen &&
                        (response.data.paymentStatus == this.$PPlusConstant.PaymentStatus_Paid ||
                         response.data.paymentStatus == this.$PPlusConstant.PaymentStatus_NeedPayExam)) {
                    this.videoId = this.$youtube.getIdFromUrl(response.data.detail.videoURL)
                    this.fields = response.data;
                    this.materialRequired = this.fields.material.filter(x => x.isRequire);
                    this.materialOptional = this.fields.material.filter(x => !x.isRequire);
                    this.contentReady = true;
                }
                else {
                    let page = this;
                    page.$router.push('/' + page.$route.params.lang + '/course/' + params.detail);

                    if (!response.data.isAuthen) {
                        setTimeout(() => {
                            page.alertPleaseLogin();
                        }, 1000);
                    }
                    else if (response.data.paymentStatus == page.$PPlusConstant.PaymentStatus_None) {
                        setTimeout(() => {
                            page.alertPleaseMakePayment(page.$router);
                        }, 1000);
                    }
                    else if (response.data.paymentStatus == page.$PPlusConstant.PaymentStatus_WaitForConfirm) {
                        setTimeout(() => {
                            page.alertPleaseWaitForPaymentConfirm();
                        }, 1000);
                    }
                }
            });
        },
        trackUserProgress() {
            let apiURL = this.$PPlusConfig.ApiURL;
            let params = this.$route.params;
            let postData = {
                courseNo: params.detail,
                chapterNo: params.chapter
            };

            this.$WeHelper.postAPI(apiURL, '/api/course/track-chapter-progress', postData, this.$PPlusEngine.getHeaderToken());
        },
        checkStatusDownload(item) {
            let isRead = this.fields.readStatus.filter(x => x.id == item.id && x.status).length > 0;

            if (isRead) {
                return true;
            }

            return false;
        },
        readFile(item) {
            window.open(item.file, '_blank');
            
            var index = this.fields.readStatus.findIndex(x => x.id == item.id);
            
            if (index == -1) {
                this.fields.readStatus.push({ id: item.id, status: true });
            }
            else {
                this.fields.readStatus[index].status = true;
            }

            this.updateReadStatus(item);
        },
        updateReadStatus(item) {
            let apiURL = this.$PPlusConfig.ApiURL;
            let postData = {
                docID: item.id
            };

            this.$WeHelper.postAPI(apiURL, '/api/course/track-document-progress', postData, this.$PPlusEngine.getHeaderToken());
        },
        playVideo() {
            this.isPlayVideo = true;
            this.trackUserProgress();
        }
    }
};
</script>

<style lang="scss">
@import '@/weact/scss/Variables.scss';

.page-chapter-detail {
    padding: 40px 0;

    .cover {
        position: relative;
        margin-bottom: 40px;

        img {
            width: 100%;
            display: block;

            &.player {
                position: absolute;
                top: 0;
                left: 0;
                z-index: 1;
                cursor: pointer;
            }
        }
    }

    .video {
        margin-bottom: 40px;

        .wrapper {
            position: relative;
            padding-bottom: 56.25%; /* 16:9 */
            height: 0;

            .crop-wrapper {
                overflow: hidden;

                .cropping {
                    overflow: hidden;
                    margin-top: -51%;
                    margin-bottom: -20.2%;

                    .player-wrapper {
                        position: relative;
                        overflow: hidden;
                        padding-top: 127.5%;

                        .player {
                            position: absolute;
                            top: 0;
                            width: 100%;
                            height: 124%;

                            iframe {
                                position: absolute;
                                top: 0;
                                left: 0;
                                width: 100%;
                                height: 100%;
                            }
                        }
                    }
                }
            }
        }
    }

    .board {
        .module {
            display: block;
            font-size: 12px;
            color: #aaa;
        }

        h1 {
            font-size: 22px;
            color: $mainColor;
            margin: 0;
            padding-bottom: 30px;

            &:after {
                content: " ";
                display: block;
                width: 100px;
                height: 1px;
                background: #ccc;
                margin-top: 15px;
            }
        }

        article {
            font-size: 14px;
            line-height: 26px;
            color: #333;

            h4 {
                font-weight: bold;
                font-size: 18px;
            }

            p, ul {
                margin: 20px 0;

                &:last-child {
                    margin-bottom: 0;
                }
            }

            img {
                display: block;
                max-width: 100%;
                margin: 30px auto;

                &:first-child {
                    margin-top: 0;
                }

                &:last-child {
                    margin-bottom: 0;
                }
            }

            img + p {
                padding: 20px 0;
            }
        }
    }

    .materials {
        background: #fff;
        padding: 7px 10px 7px 20px;
        border-left: 3px solid #e4acae;
        font-size: 14px;
        font-weight: bold;
        color: $mainColor;
        margin-bottom: 10px;

        svg {
            color: #b78b8c;
            margin-right: 10px;
        }

        @media only screen and (max-width: $screenMedium) {
            margin-top: 20px;
        }
    }

    .alert {
        font-size: 14px;
        margin-bottom: 10px;

        svg {
            color:#f3c536;
            margin-right: 10px;
        }
    }

    .download {
        background: #fff;
        padding: 5px 20px 15px;
        margin-bottom: 10px;

        button {
            display: block;
            width: 100%;
            font-size: 15px;
            color: #555;
            padding: 10px 0;
            text-align: left;
            outline: none;
            background: none;
            border: none;
            border-bottom: 1px dashed #ddd;

            &:last-child {
                border-bottom: none;
            }

            &.read {
                color: #ccc;

                i {
                    color: #20B26E;
                }

                span {
                    color: #ccc;
                }
            }

            &:hover {
                color: #333;
                text-decoration: underline;

                span {
                    color: #555;
                }
            }

            i {
                color: #ccc;
            }

            span {
                font-size: 11px;
                color: #555;
            }
        }

        i {
            font-size: 22px;
            line-height: 22px;
            margin-right: 8px;
            color: #ddd;
            @include verticalAlign(middle);
        }

        .no-material {
            margin-top: 30px;
            padding: 50px 10px;
            font-size: 14px;
            font-weight: 200;
            text-align: center;
            color: #aaa;

            i {
                display: block;
                color: #e5e5e5;
                margin-bottom: 20px;
                font-size: 60px;
            }
        }
    }

    .other {
        padding-top: 40px;

        h3 {
            font-size: 24px;
            font-weight: 200;
            color: #666;
            padding-bottom: 10px;
            margin: 0;
            margin-bottom: 30px;
            border-bottom: 1px solid #ddd;
        }
    }
}
</style>